var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex-line num-field",class:{ center: _vm.center }},[_c('div',{staticClass:"num flex-line",style:({
      'font-size': _vm.numSize + 'px',
      'margin-right': '20px',
      color: _vm.numColor || 'inherit',
    })},_vm._l((_vm.formatValue(_vm.curVal)),function(item,idx){return _c('div',{key:idx,staticClass:"digit"},[_vm._v(" "+_vm._s(item)+" ")])}),0),(_vm.unit)?_c('div',{style:({ 'font-size': _vm.unitSize + 'px', color: _vm.unitColor || 'inherit' })},[_vm._v(" "+_vm._s(_vm.unit)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }